<template>
  <b-navbar transparent type="is-black">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img
          src="@/assets/logo.png"/>
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item class="link capitalize" tag="router-link" :to="{ path: item.url }"
                     v-for="item in items" :key="item.message">
        {{$t('navbar.'+item.name)}}
      </b-navbar-item>
      <b-navbar-item>
        <div class="spacer-1" />
      </b-navbar-item>
      <b-navbar-item class="player" v-if="showPlayer || isPlaying">
        <b-tooltip :label="tooltip"
                   position="is-bottom"
                   :active="!countryDataAvailable">
          <div class="buttons">
            <b-button icon-right="play"
                      @click="play"
                      :disabled="!countryDataAvailable || isPlaying"
                      rounded/>
            <b-button icon-right="stop"
                      @click="stop"
                      :disabled="!countryDataAvailable || !isPlaying"
                      rounded />
          </div>
        </b-tooltip>
      </b-navbar-item>
      <b-navbar-item>
        <template v-if="globalDataAvailable && (showPlayer || isPlaying)">
          <span class="dateData">{{$d(new Date(globalData[currentDataIndex].day))}}</span>
        </template>
        <template v-else-if="showPlayer || isPlaying">
          <span class="dateData">{{$d(new Date())}}</span>
        </template>
      </b-navbar-item>
      <b-navbar-item  v-if="selectedCountry === undefined && (showPlayer || isPlaying)">
        <div class="highlight" v-html="$t('navbar.instructions')"></div>
      </b-navbar-item>
      <b-navbar-item class="locationContainer" v-if="selectedCountry !== undefined
       && (showPlayer || isPlaying)">
        <span class="countryName"> {{selectedCountry.countryName}}</span>
        <span class="locationData">[Lat: {{selectedCountry.lat.toFixed(2)}}, </span>
        <span class="locationData">Lon: {{selectedCountry.lon.toFixed(2)}}]</span>
      </b-navbar-item>
    </template>

    <template slot="end" >
      <b-navbar-dropdown :label="userLocale" collapsible="true" class="locale">
        <b-navbar-item v-on:click="$i18n.locale = 'en'">
          en
        </b-navbar-item>
        <b-navbar-item v-on:click="$i18n.locale = 'it'">
          it
        </b-navbar-item>
      </b-navbar-dropdown>
      <b-navbar-item v-if="showPlayer">
        <b-dropdown aria-role="menu" position="is-bottom-left" @active-change="dropdownChange">
          <b-icon icon="settings" slot="trigger"/>
          <b-dropdown-item custom
                           :focusable="false"
                           paddingless>
            <div class="controls-dropdown"><Controls /></div>
          </b-dropdown-item>
        </b-dropdown>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import Controls from '../controls/Controls.vue';
import actions from '../../store/actions';

export default {
  name: 'Navbar',
  components: {
    Controls,
  },
  data() {
    return {
      value: 5,
      isPlaying: false,
      tooltip: 'Select a location on the globe to start playing',
      items: [{
        url: '/',
        name: 'home',
      }, {
        url: '/about',
        name: 'about',
      }, {
        url: '/credits',
        name: 'credits',
      }],
      showPlayer: true,
      userLocale: this.$i18n.locale,
    };
  },
  computed: {
    playing() {
      return this.$store.state.playing;
    },
    currentDataIndex() {
      return this.$store.state.currentDataIndex;
    },
    country() {
      return this.$store.state.country;
    },
    countryDataAvailable() {
      return this.country.length > 0 && this.currentDataIndex !== undefined;
    },
    globalData() {
      return this.$store.state.globalData;
    },
    globalDataAvailable() {
      return this.globalData.length > 0 && this.currentDataIndex !== undefined;
    },
    selectedCountry() {
      return this.$store.state.selectedCountry;
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  watch: {
    playing(isPlaying) {
      this.isPlaying = isPlaying;
    },
    currentDataIndex(currentDataIndex) {
      this.getCurrentDataIndex = currentDataIndex;
    },
    $route() {
      if (this.$route.path === '/' || '') {
        this.showPlayer = true;
      } else {
        this.showPlayer = false;
      }
    },
    locale(change) {
      this.userLocale = change;
    },
  },
  methods: {
    play() {
      this.$store.dispatch(actions.PLAY);
    },
    pause() {
      this.$store.dispatch(actions.PAUSE);
    },
    stop() {
      this.getCurrentDataIndex = null;
      this.$store.dispatch(actions.STOP);
    },
    dropdownChange(isDropdownOpen) {
      const isCanvasEnabled = !isDropdownOpen;
      this.$store.dispatch(actions.CALL_SET_CANVAS_ENABLED, isCanvasEnabled);
    },
  },
  filters: {
    removeDay(dateString) {
      const parts = dateString.split(' ');
      parts.shift();
      return parts.join(' ');
    },
  },
};
</script>

<style scoped>
  nav{
    background-color: transparent;
  }
  nav{
    color: white;
  }

  a.navbar-item {
    color: white;
  }

  .link:hover {
    text-decoration: underline;
  }

  .navbar-item:hover, .navbar-item:focus, .player:focus-within {
    background-color: transparent;
  }

  .player:focus, .player:focus-visible, .player:focus-within {
    background-color: transparent;
  }

  .dateData{
    font-variant-numeric: tabular-nums;
    font-family: monospace;
  }
  .locationData {
    font-variant-numeric: tabular-nums;
    font-family: monospace;
  }

  .countryName {
    padding-right: 10px;
    color:red
  }
  .highlight {
    color:crimson
  }

  a.capitalize {
    text-transform: capitalize;
  }

  .is-active{
    text-decoration: underline;
  }
  .navbar-brand a{
    background-color: black;
  }

  .navbar-item, .navbar-item.is-active, .navbar-item:hover{
    background-color: black;
  }

  .controls-dropdown {
    width: 300px;
    padding: 20px;
  }

  a {
    color: white;
  }

</style>
